<h1 mat-dialog-title [attr.data-cy]="'mwwsdwsd_h1_1_4_'">Wartezeit Sonderfall</h1>
<div mat-dialog-content>
    <p>
        Medikament: <span [attr.data-cy]="'mwwsdwsd_span_1_16_'">{{ material?.artikel_me }}</span>
    </p>

    <kiene-tierart-selector
        #tierartSelektor
        [materialId]="material.artikel_id"
        (tierartSelectionChanged)="setArtikelTierart($event)"
    ></kiene-tierart-selector>

    <kiene-anwendungs-selector #anwendungSelektor (change)="setAnwendung($event)"></kiene-anwendungs-selector>

    <kiene-diagnose-selector #diagnoseSelektor (change)="setDiagnose($event)"></kiene-diagnose-selector>
    <div class="one-row">
        <mat-form-field style="width: 30%" [attr.data-cy]="'mwwsdwsd_mat-form-field_1_8_'">
            <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_1_9_'">Wartezeit Fleisch</mat-label>
            <input
                matInput
                type="number"
                inputmode="numeric"
                [formControl]="fleischCtrl"
                [attr.data-cy]="'mwwsdwsd_input_1_1_'"
            />
        </mat-form-field>
        <span class="spacer" [attr.data-cy]="'mwwsdwsd_span_2_16_'"></span>
        <mat-form-field style="width: 30%" [attr.data-cy]="'mwwsdwsd_mat-form-field_2_8_'">
            <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_2_9_'">Wartezeit Milch</mat-label>
            <input
                matInput
                type="number"
                inputmode="numeric"
                [formControl]="milchCtrl"
                [attr.data-cy]="'mwwsdwsd_input_2_1_'"
            />
        </mat-form-field>
        <span class="spacer" [attr.data-cy]="'mwwsdwsd_span_3_16_'"></span>
        <mat-form-field style="width: 30%" [attr.data-cy]="'mwwsdwsd_mat-form-field_3_8_'">
            <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_3_9_'">Wartezeit Eier</mat-label>
            <input
                matInput
                type="number"
                inputmode="numeric"
                [formControl]="eierCtrl"
                [attr.data-cy]="'mwwsdwsd_input_3_1_'"
            />
        </mat-form-field>
    </div>

    <mat-form-field style="width: 100%" [attr.data-cy]="'mwwsdwsd_mat-form-field_4_8_'">
        <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_4_9_'">Kommentar</mat-label>
        <input matInput type="text" [formControl]="kommentarCtrl" [attr.data-cy]="'mwwsdwsd_input_4_1_'" />
    </mat-form-field>

    <mat-form-field [attr.data-cy]="'mwwsdwsd_mat-form-field_5_8_'">
        <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_5_9_'">Menge</mat-label>
        <input matInput type="number" [formControl]="mengeCtrl" [attr.data-cy]="'mwwsdwsd_input_5_1_'" />
    </mat-form-field>

    <mat-form-field [attr.data-cy]="'mwwsdwsd_mat-form-field_6_8_'">
        <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_6_9_'">Einheit</mat-label>
        <mat-select
            [formControl]="einheitCtrl"
            [compareWith]="einheitComparator"
            [attr.data-cy]="'mwwsdwsd_mat-select_1_6_'"
        >
            <mat-option *ngFor="let u of units" [value]="u" [attr.data-cy]="'mwwsdwsd_mat-option_1_7_'">{{
                u.bezeichnung
            }}</mat-option>
        </mat-select>
    </mat-form-field>
    <div class="one-row">
        <mat-form-field style="width: 22%" [attr.data-cy]="'mwwsdwsd_mat-form-field_7_8_'">
            <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_7_9_'">Behandlung in Tagen</mat-label>
            <input matInput type="number" [formControl]="behandlungTagenCtrl" [attr.data-cy]="'mwwsdwsd_input_6_1_'" />
        </mat-form-field>

        <span class="spacer" [attr.data-cy]="'mwwsdwsd_span_4_16_'"></span>
        <mat-form-field style="width: 22%" [attr.data-cy]="'mwwsdwsd_mat-form-field_8_8_'">
            <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_8_9_'">Intervall in Stunden</mat-label>
            <input matInput type="number" [formControl]="intervallStdCtrl" [attr.data-cy]="'mwwsdwsd_input_7_1_'" />
        </mat-form-field>

        <span class="spacer" [attr.data-cy]="'mwwsdwsd_span_5_16_'"></span>
        <mat-form-field style="width: 22%" [attr.data-cy]="'mwwsdwsd_mat-form-field_9_8_'">
            <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_9_9_'">Faktor</mat-label>
            <input matInput type="number" [formControl]="faktorCtrl" [attr.data-cy]="'mwwsdwsd_input_8_1_'" />
        </mat-form-field>

        <span class="spacer" [attr.data-cy]="'mwwsdwsd_span_6_16_'"></span>
        <mat-form-field style="width: 22%" [attr.data-cy]="'mwwsdwsd_mat-form-field_10_8_'">
            <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_10_9_'">K&ouml;rpergewicht kg</mat-label>
            <input matInput type="number" [formControl]="koerpergewichtCtrl" [attr.data-cy]="'mwwsdwsd_input_9_1_'" />
        </mat-form-field>

        <span class="spacer" [attr.data-cy]="'mwwsdwsd_span_7_16_'"></span>
        <mat-form-field style="width: 22%" [attr.data-cy]="'mwwsdwsd_mat-form-field_11_8_'">
            <mat-label [attr.data-cy]="'mwwsdwsd_mat-label_11_9_'">Dosierungstext</mat-label>
            <input matInput type="text" [formControl]="dosierungTxtCtrl" [attr.data-cy]="'mwwsdwsd_input_10_1_'" />
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions>
    <span class="spacer" [attr.data-cy]="'mwwsdwsd_span_8_16_'"></span>
    <button mat-button (click)="close()" [attr.data-cy]="'mwwsdwsd_button_1_0_'">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()" [attr.data-cy]="'mwwsdwsd_button_2_0_'">Speichern</button>
</div>
